<template>
	<div class='create-lpo wrapper'>
		<div class='several-lpo-block' style='font-size: 1.1rem; margin-bottom: 1.5rem'>
			<custom-p-checkbox v-model='multipleMode' label='Включить в акт ЛПО несколько выделов' labelLeft/>
		</div>

		<AddressPickerBlock/>
		<AddAddressBlock v-if='multipleMode' @not-uniq-error='onAddNotUniq' class='add-address-block'/>
		<MultipleListBlock v-if='multipleMode' :not-uniq-address='notUniqAddress' class='lpo-list-block'/>

		<div class='btn-row'>
			<button class='create-btn' @click='create'>Создать ЛПО</button>
			<button v-if='existingLpo' @click='goToExistingLpo'>Перейти к существующему</button>
		</div>

	</div>
</template>

<script>
	import { mapState, mapMutations, mapActions } from 'vuex';

	import AddressPickerBlock from './AddressPickerBlock';
	import AddAddressBlock from './AddAddressBlock';
	import MultipleListBlock from './MultipleListBlock';

	export default {
		name: 'CreateLpo',
		components: {
			AddressPickerBlock,
			MultipleListBlock,
			AddAddressBlock
		},
		data: () => ({
			notUniqAddress: null,
			notUniqTimer: null,
		}),
		computed: {
			multipleMode: {
				get() { return this.$store.state.createLpo.multipleMode; },
				set(value) { this.setMultipleMode(value); }
			},

			...mapState('createLpo', {
				multipleList: state => state.multipleList,
				existingLpo: state => state.existingLpo
			}),

			...mapState('createLpo/address', {
				selectedFo: state => state.selectedFo,
				selectedRegion: state => state.selectedRegion,
				selectedForestry: state => state.selectedForestry,
				selectedLocalforestry: state => state.selectedLocalforestry,
				selectedSubforestry: state => state.selectedSubforestry,
				selectedArea: state => state.selectedArea,
				selectedSection: state => state.selectedSection,

				sectionLpExists: state => state.sectionLpExists,
				selectedSectionLp: state => state.selectedSectionLp
			})
		},
		watch: {
			selectedSection(section) {
				this.setExistingLpo(null);
			},
			selectedSectionLp(section) {
				this.setExistingLpo(null);
			},
		},
		methods: {
			onAddNotUniq(address) {
				this.notUniqAddress = address;

				clearTimeout(this.notUniqTimer);
				this.notUniqTimer = setTimeout(() => {
					this.notUniqAddress = null;
				}, 1000);
			},

			create() {
				this.createLpo().then(res => {
					
					this.goToLpo(res);
				}).catch(err => {
					if (err.message === '23505') {
						this.$toast.add({severity: 'warn', detail: 'Адрес уже используется в системе', life: 10000});
						this.getExistingLpo();
					} else {
						throw err;
					}
				});
			},

			goToLpo(lpo_id) {
				const route_obj = {
					name: 'lpo',
					params: {
						lpo_id: lpo_id,
					}
				};
				this.$router.push(route_obj);
			},
			goToExistingLpo() {
				this.goToLpo(this.existingLpo.lpo_id);
			},


			...mapMutations('createLpo', [
				'setMultipleMode',
				'setExistingLpo'
			]),

			...mapActions('createLpo', [
				'createLpo',
				'getExistingLpo'
			]),
		},

	};
</script>

<!-- <style scoped src='@/style/wrapper.css'></style> -->

<style scoped>
	.several-lpo-block {
		margin-bottom: 10px;
	}

	.add-address-block {
		margin-bottom: 10px;
	}

	.lpo-list-block {
		margin-bottom: 10px;
	}

	.btn-row > button {
		margin-right: 6px;
	}
</style>

<style lang='scss' scoped>
	@import '@/style/constants.scss';

	.create-lpo {
		max-width: $wrapper-max-width;
		margin: auto;

		padding: $wrapper-padding;
	}
</style>